export default __webpack_public_path__ + "static/zoomparty-8a8be75b43f89bc2f040de6dedf8c9a7.svg";